import { Col, Form, InputNumber, Row, Select } from 'antd'
import { useSidebarTenantsQuery } from '../../MyTenant/tenantsQueries'
import { filterTenantOption, toTenantOptions } from '../../MyTenant/tenantSelectModel'

const JobRefreshParametersFields = () => {
  const tenantsQuery = useSidebarTenantsQuery()

  return (
    <>
      <Form.Item name="tenantId" label="Tenant" extra="Leave blank to include every tenant.">
        <Select
          showSearch
          allowClear
          placeholder="All tenants"
          options={toTenantOptions(tenantsQuery.data ?? [])}
          filterOption={filterTenantOption}
          loading={tenantsQuery.isLoading}
        />
      </Form.Item>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="startJobId" label="Start job ID" extra="Only jobs with this ID or higher.">
            <InputNumber min={1} precision={0} placeholder="Lowest job" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="endJobId" label="End job ID" extra="Only jobs with this ID or lower.">
            <InputNumber min={1} precision={0} placeholder="Highest job" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="maxJobs" label="Max jobs" extra="Leave blank for no limit.">
        <InputNumber min={1} precision={0} placeholder="No limit" style={{ width: '100%' }} />
      </Form.Item>
    </>
  )
}

export default JobRefreshParametersFields
